import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import PrivateRoute from './privateRoutes.jsx';
import PrivateDocRoute from './PrivateDocRouter.jsx';
import Home from './pages/Home/index.jsx';
import Register from './pages/Register/index.jsx';
import RegisterResident from './pages/RegisterResident';
import CpfUserCheck from './pages/CpfUserCheck/index.jsx';
import Login from './pages/Login/index.jsx';
import AdminPanelLogin from './pages/AdminPanelLogin/index.jsx';
import DoctorLogin from './pages/DoctorLogin/index.jsx';
import NotFoundPage from './pages/NotFound/index.jsx';
import Main from './components/Main.jsx';
import ForgotPass from './pages/ForgotPass/index.jsx';
import ReplacePass from './pages/ReplacePass/index.jsx';
import InfoVerify from './pages/InfoVerify/index.jsx';
import Veriff from './pages/Veriff/index.jsx';
import BlockedPage from './pages/BlockedPage/index.jsx';
import Terms from './pages/TermsOfUse/index.jsx';
import usePageView from './utils/usePageView.js';
import BiometricAlert from './pages/BiometricAlert/index.jsx';
import {deleteCookies} from './utils/functions';
import BiometricResult from './pages/BiometricResult/index.jsx';
import BiometricResultResident from './pages/BiometricResultResident/index.jsx';
import Users from './pages/Users/index.jsx';
import DocArquives from './pages/DocArquives/index.jsx';
import ResidentConfirmed from './pages/ResidentConfirmed/index.jsx';
function Routes() {
  usePageView(); // hook chamado dentro do contexto do BrowserRouter
  return (
    <Switch>
      <Route path="/register" component={Register} />
       <Route path="/register-resident" component={RegisterResident} />
      <Route path="/login" component={Login} />
      <Route path="/forgot-pass" component={ForgotPass} />
      <Route path="/replace-pass" component={ReplacePass} />
      <Route path="/blocked-page" component={BlockedPage} />
      <Route path="/veriff-page" component={Veriff} />
      <Route path="/cpf-user-check" component={CpfUserCheck} />
      <Route path="/biometric-result" component={BiometricResult} />
      <Route path="/biometric-result-resident" component={BiometricResultResident} />
      <Route path="/info-verify" component={InfoVerify} />
      <Route path="/terms" component={Terms} />
      <Route path="/biometric-alert" component={BiometricAlert} />
      <Route path="/resident-confirmed" component={ResidentConfirmed} />
      <Route path="/admin" component={AdminPanelLogin} />
      <Route path="/admin-panel"  component={() => <Main Page={Users} />} />
      
      <Route path="/doctor" component={DoctorLogin} />
      <PrivateDocRoute path="/doctor-arquives"  component={() => <Main Page={DocArquives} />} />

      {/* Rotas protegidas */}
      <PrivateRoute exact path="/" component={() => <Main Page={Home} />} />
      
      {/* Página não encontrada */}
      <Route component={NotFoundPage} />

      {/* Página em manutenção */}
     {/* <Route path="/maintenance" component={Maintenance} /> */}

    </Switch>
  );
}
export default function Router() {
useEffect(() => {
  const handleBeforeUnload = (e) => {
    const currentPath = window.location.pathname;

    // Se NÃO for a home ("/"), então deleta os cookies
    if (currentPath !== '/') {
      deleteCookies();
    }
  };

  window.addEventListener('beforeunload', handleBeforeUnload);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, []);


  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
}
